// extracted by mini-css-extract-plugin
export default {"root":"CollapseAllMenu_root__YpghM","isCollapseAll":"CollapseAllMenu_isCollapseAll__TZMgK","collapseAllButton":"CollapseAllMenu_collapseAllButton__1AQro"};